import React from "react";
import {Button, DatePicker, Form, FormInstance, Input, Modal, Radio, Switch} from "antd";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import dayjs, {Dayjs} from "dayjs";
import {Info} from "lucide-react";
import TiptapEditor from "../../common/tiptap-editor/tiptap-editor";

interface IPollCreateProps {
    open: boolean;
    handleModalClose: () => void;
    pollForm: FormInstance;
    handlePollSubmit: () => void;
}

const PollCreateModal = (props: IPollCreateProps) => {

    const disablePastDate = (currentDate: Dayjs) => (
        currentDate.valueOf() < dayjs().startOf('day').valueOf()
    );

    const isPoll = [
        {label: 'Vote', value: true},
        {label: 'Poll', value: false},
    ];

    const showVoters = [
        {label: 'Yes', value: true},
        {label: 'No', value: false},
    ];

    const anonymous = Form.useWatch("anonymous", props.pollForm);
    const isPollSelected = anonymous === false;
    const isVoteSelected = anonymous === true;

    return (
        <Modal
            className={"hrms-app pollModal"}
            open={props.open}
            onCancel={props.handleModalClose}
            title={"Create Poll"}
            onOk={props.handlePollSubmit}
            okText={"Publish"}
        >
            <Form
                form={props.pollForm}
                layout={"vertical"}
                className="poll-form">

                <div className={'pollModal__title-eventDate-wrapper'}>
                    <Form.Item
                        label={"Title"}
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: "Please enter Poll Title",

                            },
                            {
                                max: 255,
                                message: "Title cannot exceed 255 characters.",
                            }
                        ]}>
                        <Input placeholder="Enter poll title"/>
                    </Form.Item>
                    <Form.Item
                        label={" End date & time"}
                        name={"endTime"}
                        className={'poll-date-fields'}
                        rules={[
                            {
                                required: true,
                                message: " Please select End Date & Time",
                            }
                        ]}
                    >
                        <DatePicker
                            showTime={{
                                format: " HH:mm"
                            }}
                            disabledDate={disablePastDate}
                            placeholder=" Select end date & time"
                        />
                    </Form.Item>
                </div>


                <Form.Item
                    label={"Description"}
                    name="description"
                >
                    <TiptapEditor/>
                </Form.Item>
                {
                    isPollSelected &&
                    <div className={'poll-note-description'}>
                        <p className=" info-content">
                            <Info className=" info-icon"/>
                            Select Poll to display live results and allow participants to change their vote until the
                            poll ends.
                        </p>
                    </div>
                }
                {
                    isVoteSelected &&
                    <div className={'poll-note-description'}>
                        <p className=" info-content">
                            <Info className=" info-icon"/>
                            Select Vote for anonymous voting. Votes cannot be changed after submission, and results are
                            published by the admin after voting ends.
                        </p>
                    </div>
                }

              <div className={'pollModal__specification-wrapper'}>
                  <Form.Item
                      label=" Type"
                      name={"anonymous"}
                      rules={[{required: true, message: 'Please choose either Poll or Vote!'}]}
                  >
                      <Radio.Group
                          size='large'
                          name=" radiogroup"
                          options={isPoll}
                          className={'choose-poll-and-vote'}
                      />
                  </Form.Item>
                  {isPollSelected &&
                  <Form.Item
                      label=" Show Voters?"
                      name="showVoters"
                  >
                      <Radio.Group
                          size="large"
                          options={showVoters}
                          className={'choose-voters'}
                      />
                  </Form.Item>}

                  {
                      isVoteSelected && <Form.Item
                          label="Show Vote Percentage?"
                          name="showVotePercentage"
                          valuePropName="checked"
                          initialValue={false}
                      >
                          <Switch checkedChildren="Yes" unCheckedChildren="No"/>
                      </Form.Item>
                  }

              </div>



                <Form.Item label={"Options"} required    className={'pollModal__option-list'}>
                    <Form.List
                        name="options"
                        rules={[
                            {
                                validator: async (_, options) => {
                                    if (!options || options.length < 2) {
                                        return Promise.reject(
                                            new Error("Please add at least 2 options")
                                        );
                                    }
                                },
                            },
                        ]}
                    >
                        {(fields, {add, remove}, {errors}) => (
                            <>
                                {fields.map(({key, name, ...restField}) => (
                                    <div
                                        key={key}
                                       className={'pollModal__option-wrapper'}
                                    >
                                        <Form.Item
                                            className={'pollModal__option'}
                                            {...restField}
                                            name={name}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please enter an option",
                                                },
                                                {
                                                    max: 80,
                                                    message: "Option cannot exceed 80 characters.",
                                                },
                                            ]}
                                        >
                                            <Input placeholder={`Option ${name + 1}`}/>
                                        </Form.Item>

                                        <Button
                                            className={'pollModal__delete-option-btn'}
                                            danger
                                            icon={<DeleteOutlined/>}
                                            onClick={() => remove(name)}
                                        />
                                    </div>
                                ))}

                                <Button
                                    className={'pollModal__add-option-btn'}
                                    type="primary"
                                    onClick={() => add()}
                                    icon={<PlusOutlined/>}
                                    //block property makes a button expand horizontally to fill the full width of its parent container.
                                    block
                                >
                                    Add Option
                                </Button>

                                <Form.ErrorList errors={errors}/>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

            </Form>
        </Modal>
    )
}

export default PollCreateModal;
